import { render } from "./SearchWidget.vue?vue&type=template&id=38189e2d"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/3nb/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/SearchWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38189e2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38189e2d', __exports__)) {
    console.log('reload')
    api.reload('38189e2d', __exports__)
  }
  
  module.hot.accept("./SearchWidget.vue?vue&type=template&id=38189e2d", () => {
    console.log('re-render')
    api.rerender('38189e2d', render)
  })

}


export default __exports__